import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Pm10040View from "../../Views/Purchase/PM10040";
import Snackbar from "../../Components/Snackbar";

function PM10040(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [searchDate, setSearchDate] = React.useState(new Date());
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  let selectedPoNo = "";
  const [endDate, setEndDate] = React.useState(new Date());

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10040.GetPurchaseStockIns,
        {
          StartDate: new Date(startDate),
          EndDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        console.log(data);
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              stockInDt: data[i].stockInDt
                ? Commons.DateFormating(data[i].stockInDt.toString(), 2)
                : "",
              poNo: data[i].poNo,
              stockInNo: data[i].stockInNo,
              custNm: data[i].custNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              poItemQty: data[i].poItemQty,
              poAddItemQty: data[i].poAddItemQty,
              itemStdAmt: data[i].itemStdAmt,
              inQty: data[i].inQty,
              inAddQty: Commons.splitReserveFun(
                data[i].inQty,
                data[i].itemFormula
              ),
              itemUnit: data[i].itemUnit,
              poCreateDt: data[i].poCreateDt
                ? Commons.DateFormating(data[i].poCreateDt.toString(), 2)
                : "",
              inItemAmt: data[i].inItemAmt,
              inWhNm: data[i].whNm,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <Pm10040View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        SearchLogic={SearchLogic}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default PM10040;
